
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";

const EMPLOYER_ILR_SERVICE_REQUEST_ALIAS = "employer_ilr";

const SERVICE = {
  id: 1,
  alias: EMPLOYER_ILR_SERVICE_REQUEST_ALIAS,
  title: "Indefinite Leave to Remain (ILR)",
  paragraph_1:
    "If your international employees become eligible to apply for ‘Indefinite Leave to Remain’ (ILR)\n" +
    " you can support them in obtaining it.",
  paragraph_2:
    "One applicant has to pay £2,400 in Home Office fees for their ILR application.\n" +
    " If application is rejected the fees are not refundable. Therefore, many individuals hire immigration service\n" +
    " providers to ensure that their application is approved the first time, and it might be costly.",
  paragraph_3:
    "Our research shows that employees that do not get support with their ILR process from their employers\n" +
    " feel demotivated, their loyalty is most likely to decline and they might look for employment elsewhere.",
  benefitsTitle: "You can support your employees via our ILR service when we:",
  benefits: [
    "Prepare and submit ILR application, collect all required documents and draft a cover letter",
    "Represent your employee in front of the Home Office during the ILR process",
    "Provide on-call immigration expert support",
    "Take care of all activities necessary for the ILR application to be successful",
    "Communicate with the Home Office",
  ],
  feeTitle: "For a fixed fee",
  fee: 800,
  feeDescription: "+ VAT (not including the Home Office fees)",
};

const INITIAL_SERVICE_REQUEST_OPTION = 1;

@Component
export default class WidgetILR extends Vue {
  service = SERVICE;

  popup = false;

  selectedOption = INITIAL_SERVICE_REQUEST_OPTION;

  openPopup() {
    this.$emit("start");

    this.popup = true;
  }

  closePopup() {
    this.popup = false;
  }

  // NOTE: If services number will be more then 1, use implementation like in "WidgetSkilledWorkerVisa" component;
  getServiceAlias() {
    const item = this.service;

    if (!item) return null;

    return item.alias;
  }

  async submitRequest() {
    const alias = this.getServiceAlias();

    if (!alias) return;

    try {
      await this.axios.get(API_ROUTES.SERVICE_REQUEST(alias));

      this.$emit("on-submit");
    } finally {
      this.closePopup();
    }
  }
}
